import { COMPLETE_SIGNUP_NUDGE_VARIANTS, CompleteSignupNudgeVariant } from './constants'

const VARIANT_VALUES: readonly string[] = Object.values(COMPLETE_SIGNUP_NUDGE_VARIANTS)

export function isCompleteSignupNudgeVariant(value: unknown): value is CompleteSignupNudgeVariant {
  return typeof value === 'string' && VARIANT_VALUES.includes(value)
}

export function isCompleteSignupNudgeShown(variant: CompleteSignupNudgeVariant | null): boolean {
  return isCompleteSignupNudgeVariant(variant) && variant !== COMPLETE_SIGNUP_NUDGE_VARIANTS.CONTROL
}
